import { jsx as f } from "react/jsx-runtime";
import { c as o } from "../../../../clsx-OuTLNxxd.js";
const l = {
  "flex-children": "_flex-children_7pjb4_29",
  "justify-self-start": "_justify-self-start_7pjb4_29",
  "justify-self-end": "_justify-self-end_7pjb4_32",
  "justify-self-center": "_justify-self-center_7pjb4_35",
  "align-self-start": "_align-self-start_7pjb4_38",
  "align-self-end": "_align-self-end_7pjb4_41",
  "align-self-center": "_align-self-center_7pjb4_44",
  "is-full-width": "_is-full-width_7pjb4_47",
  "dialog-overlay-show": "_dialog-overlay-show_7pjb4_1",
  "dialog-content-show": "_dialog-content-show_7pjb4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7pjb4_1"
}, d = ({ alignSelf: s, justifySelf: e, children: t, isFullWidth: i, ..._ }) => {
  const n = o(
    l["flex-children"],
    s && l[`align-self-${s}`],
    e && l[`justify-self-${e}`],
    i && l["is-full-width"]
  );
  return /* @__PURE__ */ f("div", { className: n, ..._, children: t });
};
export {
  d as FlexChildren
};
